'use client';
import { useEffect } from 'react';

import { useSetAtom } from 'jotai';

import { pageTypeAtom } from 'Atoms/App/PageTypeAtom';
import { filterUpdateStartedAtom } from 'Atoms/App/Plp/FilterUpdateStarted';

type Props = {
  plpHeader?: string;
  filtrsStr: string;
};

export const ClientTasks = ({ filtrsStr }: Props) => {
  const setFilterUpdateStarted = useSetAtom(filterUpdateStartedAtom);
  const setPageType = useSetAtom(pageTypeAtom);

  useEffect(() => {
    setFilterUpdateStarted(false);
    setPageType('plp');
  }, [filtrsStr]);

  return undefined;
};
